<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<template lang="html">
  <div>
    <!-- Mobile Navigation -->
    <MobileNavigation v-if="isMobile" />
    
    <!-- Desktop Navigation -->
    <DesktopNavigation v-else />
  </div>
</template>

<script>
import MobileNavigation from "@/components/Elements/ElMobileNavigation.vue";
import DesktopNavigation from "@/components/Elements/ElDesktopNavigation.vue";

export default {
  name: "ElNavigationWrapper",
  components: {
    MobileNavigation,
    DesktopNavigation,
  },
  props: {
    footer: null,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
